// extracted by mini-css-extract-plugin
export default {"homePageContainer":"HomePage_homePageContainer__0JJWP","skeletonContainer":"HomePage_skeletonContainer__hb-rF"};